import {NgModule} from '@angular/core';
import {MaterialModule} from '../material/material.module';
import {TemplateColumnEditorDialogComponent} from './components/template-column-editor-dialog/template-column-editor-dialog.component';
import {ReportsComponent} from './components/reports/reports.component';
import {ReportEditComponent} from './components/report-edit/report-edit.component';
import {ReportComponent} from './components/report/report.component';
import {TemplateFieldListItemComponent} from './components/template-field-list-item/template-field-list-item.component';
import {ViewReportResultComponent} from './components/view-report-result/view-report-result.component';
import {ReportTemplateService} from './services/report-template/report-template.service';
import {ReportTemplateColumnService} from './services/report-template-column/report-template-column.service';
import {ReportFormulaTestService} from './services/report-formula-test/report-formula-test.service';
import {ReportService} from './services/report/report.service';
import {UtilitiesModule} from '../utilities/utilities.module';
import {FormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {ReportNameResolverService} from './resolvers/report-name-resolver.service';
import {ReportEditNameResolverService} from './resolvers/report-edit-name-resolver.service';
import { ReportViewComponent } from './components/report-view/report-view.component';
import {ReportViewResolverService} from './resolvers/report-view-resolver.service';

@NgModule({
  declarations: [
    TemplateColumnEditorDialogComponent,
    ReportsComponent,
    ReportEditComponent,
    ReportComponent,
    TemplateFieldListItemComponent,
    ViewReportResultComponent,
    ReportViewComponent
  ],
  entryComponents: [
    TemplateColumnEditorDialogComponent,
  ],
  imports: [
    MaterialModule,
    UtilitiesModule,
    MaterialModule,
    CommonModule,
    FormsModule,
  ],
  exports: [
    ReportComponent,
    ReportsComponent
  ],
  providers: [
    ReportTemplateService,
    ReportTemplateColumnService,
    ReportFormulaTestService,
    ReportService,
    ReportNameResolverService,
    ReportEditNameResolverService,
    ReportViewResolverService
  ]
})
export class ReportModule { }



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/report/report.module.ts